// @ts-nocheck

import { useEffect, useCallback } from 'react';

import type { Game } from '@shared/types';

import useAxios from '@services/api';

import { FormInputs, GameBuild } from './client.types';

// Хук для получения настроек игры по умолчанию
export const useFetchGameDefaults = (gameName: string) => {
  const { response, error, issueRequest } = useAxios<Game>();

  useEffect(() => {
    void issueRequest({ url: `/games/${gameName}`, method: 'get' });
  }, [gameName, issueRequest]);

  return response;
};

// Хук для получения существующей сборки игры
export const useFetchGameBuild = (gameBuildId: string) => {
  const { response, error, issueRequest, loading } = useAxios<GameBuild>();

  const fetchGameBuild = useCallback(() => {
    if (gameBuildId && gameBuildId !== 'undefined') {
      void issueRequest({ url: `/public/games/build-data/${gameBuildId}`, method: 'get' });
    }
  }, [gameBuildId, issueRequest]);

  // Автоматически делаем запрос при изменении gameBuildId
  useEffect(() => {
    if (gameBuildId && gameBuildId !== 'undefined' && !response) {
      fetchGameBuild();
    }
  }, [gameBuildId, response, fetchGameBuild]);

  return [response, fetchGameBuild, error, loading] as const;
};

// Хук для создания новой сборки игры
export const useCreateGameBuild = () => {
  const { response, error, issueRequest, loading, setLoading } = useAxios<GameBuild>();

  const handleSubmit = useCallback(
    async (formData: FormData) => {
      setLoading(true);

      return await issueRequest({
        method: 'PUT',
        url: '/games/build/flappy',
        body: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    [issueRequest]
  );

  return [response, handleSubmit, loading] as const;
};

// Хук для установки даты активации игры
export const useSetActivateGameDate = () => {
  const { response, error, issueRequest, loading } = useAxios<Record<string, never>>();

  const setActivateGameDate = useCallback((id: string) => {
    return issueRequest({ url: `/games/keys/${id}`, method: 'put' });
  }, [issueRequest]);

  return [setActivateGameDate, loading] as const;
};
